import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'login-1',
        path: `${AUTH_PREFIX_PATH}/login-1`,
        component: React.lazy(() => import('views/auth-views/authentication/login-1')),
    },
    {
        key: 'login-2',
        path: `${AUTH_PREFIX_PATH}/login-2`,
        component: React.lazy(() => import('views/auth-views/authentication/login-2')),
    },
    {
        key: 'register-1',
        path: `${AUTH_PREFIX_PATH}/register-1`,
        component: React.lazy(() => import('views/auth-views/authentication/register-1')),
    },
    {
        key: 'register-2',
        path: `${AUTH_PREFIX_PATH}/register-2`,
        component: React.lazy(() => import('views/auth-views/authentication/register-2')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'error-page-1',
        path: `${AUTH_PREFIX_PATH}/error-page-1`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
    },
    {
        key: 'error-page-2',
        path: `${AUTH_PREFIX_PATH}/error-page-2`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-2')),
    },
]

export const protectedRoutes = [
  ///useraddress
  {
    key: "dashboard.useraddress",
    path: `${APP_PREFIX_PATH}/dashboards/useraddress`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/useraddress/useraddress_list")
    ),
  },
  {
    key: "dashboard.add_useraddress",
    path: `${APP_PREFIX_PATH}/dashboards/add_useraddress`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/useraddress/add_useraddress")
    ),
  },
  {
    key: "dashboard.edit_useraddress",
    path: `${APP_PREFIX_PATH}/dashboards/edit_useraddress/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/useraddress/edit_useraddress")
    ),
  },
  ///featureoptions
  {
    key: "dashboard.featureoptions",
    path: `${APP_PREFIX_PATH}/dashboards/featureoptions`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/featureoptions/featureoptions_list")
    ),
  },
  {
    key: "dashboard.add_featureoptions",
    path: `${APP_PREFIX_PATH}/dashboards/add_featureoptions`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/featureoptions/add_featureoptions")
    ),
  },
  {
    key: "dashboard.edit_featureoptions",
    path: `${APP_PREFIX_PATH}/dashboards/edit_featureoptions/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/featureoptions/edit_featureoptions")
    ),
  },
  {
    key: "dashboard.featureOptionDetail",
    path: `${APP_PREFIX_PATH}/dashboards/featureOptionDetail/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/featureoptions/FeatureOptionDetail")
    ),
  },
  ///sliders
  {
    key: "dashboard.sliders",
    path: `${APP_PREFIX_PATH}/dashboards/sliders`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/sliders/sliders_list")
    ),
  },
  {
    key: "dashboard.add_sliders",
    path: `${APP_PREFIX_PATH}/dashboards/add_sliders`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/sliders/add_sliders")
    ),
  },
  {
    key: "dashboard.edit_sliders",
    path: `${APP_PREFIX_PATH}/dashboards/edit_sliders/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/sliders/edit_sliders")
    ),
  },
  ///badges
  {
    key: "dashboard.badges",
    path: `${APP_PREFIX_PATH}/dashboards/badges`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/badges/badges_list")
    ),
  },
  {
    key: "dashboard.add_badges",
    path: `${APP_PREFIX_PATH}/dashboards/add_badges`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/badges/add_badges")
    ),
  },
  {
    key: "dashboard.edit_badges",
    path: `${APP_PREFIX_PATH}/dashboards/edit_badges/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/badges/edit_badges")
    ),
  },
  ///baskets
  {
    key: "dashboard.baskets",
    path: `${APP_PREFIX_PATH}/dashboards/baskets`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/baskets/baskets_list")
    ),
  },
  {
    key: "dashboard.add_baskets",
    path: `${APP_PREFIX_PATH}/dashboards/add_baskets`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/baskets/add_baskets")
    ),
  },
  {
    key: "dashboard.edit_baskets",
    path: `${APP_PREFIX_PATH}/dashboards/edit_baskets/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/baskets/edit_baskets")
    ),
  },
  ///contactus
  {
    key: "dashboard.contactus",
    path: `${APP_PREFIX_PATH}/dashboards/contactus`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/contactus/contactus_list")
    ),
  },
  {
    key: "dashboard.add_contactus",
    path: `${APP_PREFIX_PATH}/dashboards/add_contactus`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/contactus/add_contactus")
    ),
  },
  {
    key: "dashboard.edit_contactus",
    path: `${APP_PREFIX_PATH}/dashboards/edit_contactus/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/contactus/edit_contactus")
    ),
  },
  ///ourservices
  {
    key: "dashboard.ourservices",
    path: `${APP_PREFIX_PATH}/dashboards/ourservices`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/ourservices/ourservices_list")
    ),
  },
  {
    key: "dashboard.add_ourservices",
    path: `${APP_PREFIX_PATH}/dashboards/add_ourservices`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/ourservices/add_ourservices")
    ),
  },
  {
    key: "dashboard.edit_ourservices",
    path: `${APP_PREFIX_PATH}/dashboards/edit_ourservices/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/ourservices/edit_ourservices")
    ),
  },
  ///wishlist
  {
    key: "dashboard.wishlist",
    path: `${APP_PREFIX_PATH}/dashboards/wishlist`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/wishlist/wishlist_list")
    ),
  },
  {
    key: "dashboard.add_wishlist",
    path: `${APP_PREFIX_PATH}/dashboards/add_wishlist`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/wishlist/add_wishlist")
    ),
  },
  {
    key: "dashboard.edit_wishlist",
    path: `${APP_PREFIX_PATH}/dashboards/edit_wishlist/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/wishlist/edit_wishlist")
    ),
  },
  ///seodatas
  {
    key: "dashboard.seodatas",
    path: `${APP_PREFIX_PATH}/dashboards/seodatas`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/seodatas/seodatas_list")
    ),
  },
  {
    key: "dashboard.add_seodatas",
    path: `${APP_PREFIX_PATH}/dashboards/add_seodatas`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/seodatas/add_seodatas")
    ),
  },
  {
    key: "dashboard.edit_seodatas",
    path: `${APP_PREFIX_PATH}/dashboards/edit_seodatas/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/seodatas/edit_seodatas")
    ),
  },
  ///seometas
  {
    key: "dashboard.seometas",
    path: `${APP_PREFIX_PATH}/dashboards/seometas`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/seometas/seometas_list")
    ),
  },
  {
    key: "dashboard.add_seometas",
    path: `${APP_PREFIX_PATH}/dashboards/add_seometas`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/seometas/add_seometas")
    ),
  },
  {
    key: "dashboard.edit_seometas",
    path: `${APP_PREFIX_PATH}/dashboards/edit_seometas/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/seometas/edit_seometas")
    ),
  },
  ///seourls
  {
    key: "dashboard.seourls",
    path: `${APP_PREFIX_PATH}/dashboards/seourls`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/seourls/seourls_list")
    ),
  },
  {
    key: "dashboard.add_seourls",
    path: `${APP_PREFIX_PATH}/dashboards/add_seourls`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/seourls/add_seourls")
    ),
  },
  {
    key: "dashboard.edit_seourls",
    path: `${APP_PREFIX_PATH}/dashboards/edit_seourls/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/seourls/edit_seourls")
    ),
  },
  ///settings
  {
    key: "dashboard.settings",
    path: `${APP_PREFIX_PATH}/dashboards/settings`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/settings/settings_list")
    ),
  },
  {
    key: "dashboard.add_settings",
    path: `${APP_PREFIX_PATH}/dashboards/add_settings`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/settings/add_settings")
    ),
  },
  {
    key: "dashboard.edit_settings",
    path: `${APP_PREFIX_PATH}/dashboards/edit_settings/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/settings/edit_settings")
    ),
  },
  ///categories
  {
    key: "dashboard.categories",
    path: `${APP_PREFIX_PATH}/dashboards/categories`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/categories/categories_list")
    ),
  },
  {
    key: "dashboard.add_categories",
    path: `${APP_PREFIX_PATH}/dashboards/add_categories`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/categories/add_categories")
    ),
  },
  {
    key: "dashboard.edit_categories",
    path: `${APP_PREFIX_PATH}/dashboards/edit_categories/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/categories/edit_categories")
    ),
  },
  {
    key: "dashboard.edit_categories",
    path: `${APP_PREFIX_PATH}/dashboards/detail_categories/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/categories/detail_categories")
    ),
  },
  ///Brands
  {
    key: "dashboard.brands",
    path: `${APP_PREFIX_PATH}/dashboards/brands`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/brands/brand_list")
    ),
  },
  {
    key: "dashboard.add_brands",
    path: `${APP_PREFIX_PATH}/dashboards/add_brands`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/brands/add_brand")
    ),
  },
  {
    key: "dashboard.edit_brands",
    path: `${APP_PREFIX_PATH}/dashboards/edit_brands/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/brands/edit_brand")
    ),
  },
  ///Blog
  {
    key: "dashboard.blog",
    path: `${APP_PREFIX_PATH}/dashboards/blog`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/blog/blog_list")
    ),
  },
  {
    key: "dashboard.add_blog",
    path: `${APP_PREFIX_PATH}/dashboards/add_blog`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/blog/add_blog")
    ),
  },
  {
    key: "dashboard.edit_blog",
    path: `${APP_PREFIX_PATH}/dashboards/edit_blog/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/blog/edit_blog")
    ),
  },
  ///Partners
  {
    key: "dashboard.partners",
    path: `${APP_PREFIX_PATH}/dashboards/partners`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/partners/partners_list")
    ),
  },
  {
    key: "dashboard.add_partners",
    path: `${APP_PREFIX_PATH}/dashboards/add_partners`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/partners/add_partners")
    ),
  },
  {
    key: "dashboard.edit_partners",
    path: `${APP_PREFIX_PATH}/dashboards/edit_partners/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/partners/edit_partners")
    ),
  },
  ///Products
  {
    key: "dashboard.edit_products",
    path: `${APP_PREFIX_PATH}/dashboards/edit_products/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/products/edit_products/index")
    ),
  },
  {
    key: "dashboard.add_products",
    path: `${APP_PREFIX_PATH}/dashboards/add_products`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/products/add_products")
    ),
  },
  {
    key: "dashboard.products",
    path: `${APP_PREFIX_PATH}/dashboards/products`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/products/products_list")
    ),
  },
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
];